module.exports = __webpack_public_path__ + "media/thumbnails/headgear-style-1-5fbbce1f.svg";